import '../css/base.scss';

import { Tooltip, Collapse, Tab, util } from 'bootstrap';
import MatchHeight from 'matchheight'; //add data-mh in the code

import Swiper, {
	Navigation,
	Pagination,
	FreeMode,
	HashNavigation,
	Mousewheel,
	Autoplay,
	Keyboard,
	History,
	Grid,
} from 'swiper';

import { gsap } from 'gsap';

import Selectric from 'selectric';
import simpleParallax from 'simple-parallax-js';
import { animationGsap } from './components/animations-gsap';
import goToAnchor from './components/goToAnchor';
import headerHeight from './components/headerHeight';
import { breakpoint } from './utils/global.js';

document.addEventListener('DOMContentLoaded', () => {
	goToAnchor();
});

$(function () {
	headerHeight();
	$('select').selectric();

	var swiperCampus = undefined;
	var SwiperTimeline = undefined;

	//paralax img
	var image = document.getElementsByClassName('paralax-img');
	new simpleParallax(image);

	//tooltip
	const tooltipTriggerList = document.querySelectorAll(
		'[data-bs-toggle="tooltip"]'
	);
	const tooltipList = [...tooltipTriggerList].map(
		tooltipTriggerEl => new Tooltip(tooltipTriggerEl)
	);

	var swiperCampus = undefined;
	// --------------------------------------------------------------------------------
	// Campus slider on archive page campus
	// --------------------------------------------------------------------------------

	// change bg, in campus page
	function changeBg(swiper) {
		var activeSlide = $('.campus-card.swiper-slide-active').data('slide'); //swiper.activeIndex;
		var total = swiper.slides.length;
		var bgToHide = $('.hero-header .bg[data-slide].bg-active');
		var bgToDisplay = $('.hero-header .bg[data-slide=' + activeSlide + ']');

		bgToHide.removeClass('bg-active');
		bgToDisplay.addClass('bg-active');

		if (document.querySelector('.swiper-campus')) {
			var slideBg = gsap.timeline({ defaults: { ease: 'Power1.easeNone' } });
			slideBg
				.fromTo(bgToHide, { duration: 1, autoAlpha: 1 }, { autoAlpha: 0 })
				.fromTo(
					bgToDisplay,
					{ duration: 1, scale: 1.05, autoAlpha: 0 },
					{ scale: 1, autoAlpha: 1 },
					'0'
				);
		}
	}

	function initSwiperCampus() {
		if (document.querySelector('.swiper-campus') !== null) {
			swiperCampus = new Swiper('.swiper-campus', {
				modules: [Navigation, Pagination, HashNavigation, Autoplay, Keyboard],
				// -----unrelated settings start -----
				slidesPerView: 1,
				centeredSlides: true,
				keyboard: true,
				loop: true,

				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				navigation: {
					nextEl: '.swiper-campus .swiper-button-next',
					prevEl: '.swiper-campus .swiper-button-prev',
				},
				speed: 1000,
				// effect: "fade",
				// fadeEffect: { crossFade: true },
				// virtualTranslate: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				grabCursor: true,
				hashNavigation: {
					watchState: true,
				},

				on: {
					init() {
						const swiper = this;
						changeBg(swiper);
					},
					slideChangeTransitionStart: function () {
						const swiper = this;
						changeBg(swiper);
					},
				},
			});
		}
	}
	initSwiperCampus();

	//--------------- END

	// animation menu
	if (document.querySelector('.hamburger')) {
		$(document).on('click', '.hamburger', function (e) {
			$('#navigation-mobile').slideToggle();
			$(this).toggleClass('is-active');
		});

		$(document).on(
			'click',
			'#navigation-mobile .toggle-line-menu',
			function (e) {
				if (!$(this).hasClass('is-active')) {
					$('.sub-menu').slideUp();
					$('#navigation-mobile .toggle-line-menu').removeClass('is-active');
					$(this).parent().next('.sub-menu').slideDown();
					$(this).addClass('is-active');
				} else {
					$('.sub-menu').slideUp();
					$('#navigation-mobile .toggle-line-menu').removeClass('is-active');
				}
			}
		);
	}

	if (document.querySelector('.toggle_opener')) {
		// open conten hiding in mobile
		$(document).on('click', '.toggle_opener', function (e) {
			e.preventDefault();
			let toggleContent = $(this).parent().parent().find('.toggle_content');
			toggleContent.slideToggle();
			$(this).toggleClass('open');
		});
	}

	// keep track of swiper instances to destroy later
	let swiperInteret;
	let swiperEartSup;
	let swiperSimple;
	let swiperOnglet;
	let swiperContact;
	let swiperBig;
	let swiperCommitments;

	const breakpointChecker = function () {
		// if larger viewport and multi-row layout needed
		if (breakpoint.matches === true) {
			//(min-width:768px)'

			if (swiperInteret !== undefined) {
				swiperInteret.destroy(true, true);
			}

			if (swiperEartSup !== undefined) {
				swiperEartSup.destroy(true, true);
			}

			if (swiperContact !== undefined) {
				swiperContact.destroy(true, true);
			}

			if (swiperContact !== undefined) {
				swiperCommitments.destroy(true, true);
			}

			// or/and do nothing
			return;
			// else if a small viewport and single column layout needed
		} else if (breakpoint.matches === false) {
			// fire small viewport version of swiper
			enableSwiperInteret();
			enableSwiperEartsup();
			enableSwiperContact();
			enableSwiperCommitments();
		}
	};

	const enableSwiperCommitments = function () {
		// init swiper
		if (document.querySelector('.swiper-commitments') !== null) {
			swiperCommitments = new Swiper('.swiper-commitments', {
				modules: [Pagination, Autoplay],
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				speed: 500,
				loop: true,
				slidesPerView: 'auto',
				autoplay: 3000,
				centeredSlides: true,
				autoplayDisableOnInteraction: false,
				grabCursor: true,
			});
		}
	};

	const enableSwiperInteret = function () {
		if (document.querySelector('#formation-interets') !== null) {
			swiperInteret = new Swiper('#formation-interets .swiper-container', {
				modules: [Pagination],
				slidesPerView: '1',
				grabCursor: true,
				spaceBetween: 30,
				loop: true,
				slidesPerGroup: 1,
				autoHeight: false,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			});
		}
	};

	const enableSwiperEartsup = function () {
		if (document.querySelector('.slider-eartsup') !== null) {
			$('.slider-eartsup').each(function (i) {
				var names = [];
				$(this)
					.find('.swiper-slide')
					.each(function (i) {
						names.push($(this).data('hash'));
					});

				swiperEartSup = new Swiper($(this)[0], {
					modules: [HashNavigation, Pagination],
					slidesPerView: '1',
					grabCursor: true,
					loop: false,
					slidesPerGroup: 1,
					autoHeight: true,
					hashNavigation: {
						watchState: true,
					},

					pagination: {
						el: this.parentNode.querySelector('.nav-slider-inner'),
						clickable: true,
						renderBullet: function (index, className) {
							let text =
								"<div style='width: " +
								100 / names.length +
								"%' data-target='" +
								[index] +
								"' class=" +
								className +
								" ><svg class='svg svg-" +
								names[index] +
								"'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#svg-" +
								names[index] +
								"'></use></svg></div>";
							return text;
						},
					},

					on: {
						slideChange: function (swiper, index) {
							let item_number = swiper.pagination.bullets.length;
							let target = swiper.activeIndex;
							let activeNavEl = swiper.el.parentNode.querySelector(
								'.nav-slider .active-nav'
							);
							activeNavEl.style.marginLeft = target * (100 / item_number) + '%';
						},
					},
				});
			});
		}
	};

	const enableSwiperContact = function () {
		if (document.querySelector('.slider-contact') !== null) {
			$('.slider-contact').each(function (i) {
				var names = [];
				$(this)
					.find('.swiper-slide')
					.each(function (i) {
						names.push($(this).data('title'));
					});

				swiperContact = new Swiper($(this)[0], {
					modules: [HashNavigation, Pagination],
					slidesPerView: '1',
					grabCursor: true,
					loop: false,
					slidesPerGroup: 1,
					autoHeight: false,
					spaceBetween: 15,
					hashNavigation: {
						watchState: true,
					},

					pagination: {
						el: this.parentNode.querySelector('.nav-slider-inner'),
						clickable: true,
						renderBullet: function (index, className, total) {
							let text =
								"<span data-target='" +
								[index] +
								"' class=" +
								className +
								' >' +
								names[index] +
								'</span>';
							return text;
						},
					},
				});
			});
		}
	};

	// keep an eye on viewport size changes
	breakpoint.addListener(breakpointChecker);
	// kickstart
	breakpointChecker();

	function paddingBigSlide() {
		if (document.querySelector('.swiper-contentBig') !== null) {
			var bigSlideTitle = $('.swiper-contentBig')
				.find('.title-page')
				.outerHeight(true);
			bigSlideTitle = bigSlideTitle / 10 + 12 + 'rem';
			$('.swiper-contentBig .swiper-slide').each(function (i) {
				$(this).css('padding-top', bigSlideTitle);
				// $(this).css('padding-bottom', bigSlideTitle);
			});
		}
	}
	paddingBigSlide();

	window.addEventListener('resize', function () {
		paddingBigSlide();
	});

	const sliderCard = document.querySelectorAll('.swiper-card-col');
	if (sliderCard !== null) {
		// also on single projet studient

		sliderCard.forEach(slider => {
			new Swiper(slider, {
				modules: [Pagination],
				slidesPerView: 3,
				slidesPerGroup: 3,
				grabCursor: true,
				spaceBetween: 15,
				pagination: {
					el: slider.querySelector('.swiper-pagination'),
					type: 'bullets',
					clickable: true,
				},

				breakpoints: {
					// when window width is >= 640px
					768: {
						spaceBetween: 30,
						autoHeight: false, // pas de autoheigght, sinon bug,
					},
				},
			});
		});
	}

	const enableSwiperContentBig = function () {
		if (document.querySelector('.swiper-contentBig') !== null) {
			$('.swiper-contentBig').each(function (i) {
				swiperBig = new Swiper($(this)[0], {
					modules: [Pagination],
					slidesPerView: 1,
					slidesPerGroup: 1,
					autoHeight: false,
					spaceBetween: 15,
					direction: 'horizontal',
					grabCursor: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					breakpoints: {
						// when window width is >= 768px
						768: {
							spaceBetween: 0,
						},
					},

					on: {
						slideChange: function (index) {
							pauseVideoShortcode();
						},
					},
				});
			});
		}
	};

	const enableSwiperSimple = function () {
		const swiperSimple = document.querySelectorAll('.swiper-simple');
		if (swiperSimple !== null) {
			// also on single projet studient

			swiperSimple.forEach(slider => {
				const swiperSimple = new Swiper(slider, {
					modules: [Pagination],
					slidesPerView: 1,
					slidesPerGroup: 1,
					grabCursor: true,
					spaceBetween: 15,
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
					},

					breakpoints: {
						// when window width is >= 640px
						768: {
							spaceBetween: 30,
							autoHeight: true,
						},
					},

					on: {
						slideChange: function (index) {
							pauseVideoShortcode();
						},
					},
				});
			});
		}
	};

	const enableSwiperOnglet = function () {
		const sliderOnglet = document.querySelectorAll('.slider-onglet');
		if (sliderOnglet !== null) {
			sliderOnglet.forEach(slider => {
				var names = [];
				slider.querySelectorAll('.swiper-slide').forEach(el => {
					names.push(el.getAttribute('data-title'));
				});

				swiperOnglet = new Swiper(slider, {
					modules: [HashNavigation, Pagination, History],
					slidesPerView: 1,
					grabCursor: true,
					spaceBetween: 15,
					loop: false,
					autoHeight: false,
					slidesPerGroup: 1,

					hashNavigation: {
						watchState: true,
						replaceState: true,
					},
					breakpoints: {
						// when window width is >= 640px
						768: {
							spaceBetween: 30,
							autoHeight: true,
						},
					},

					pagination: {
						el: slider.parentNode.querySelector('.nav-slider-inner'), // entête
						clickable: true,
						renderBullet: function (index, className) {
							var i = index;
							var text =
								"<div data-target='" +
								[i] +
								"' class=" +
								className +
								' ><span>' +
								names[i] +
								'</span></div>';
							return text;
						},
					},

					on: {
						slideChange: function (slider, index) {
							activeBullet(slider);
							pauseVideoShortcode();
						},
					},
				});

				/// pagination custom bullets

				for (var i = 0; i <= swiperOnglet.slides.length - 1; i++) {
					if (i === 0) {
						// add active class if it is the first bullet
						slider.querySelector('.swiper-pagination').innerHTML +=
							'<span class="swiper-bullet-custom swiper-pagination-bullet' +
							' ' +
							'swiper-pagination-bullet-active' +
							' ' +
							'slide' +
							i +
							'" data-target=' +
							i +
							' ></span>';
					} else {
						slider.querySelector('.swiper-pagination').innerHTML +=
							'<span data-target=' +
							i +
							' class="swiper-bullet-custom swiper-pagination-bullet' +
							' ' +
							'slide' +
							i +
							'"></span>';
					}
				}
			});
		}
	};

	const swiperNavScrollEls = document.querySelectorAll('.swiper-navbar-scroll');
	if (swiperNavScrollEls.length > 0) {
		swiperNavScrollEls.forEach(function (el) {
			let swiperNav = new Swiper(el, {
				modules: [FreeMode, Mousewheel],
				slidesPerView: 'auto',
				grabCursor: true,
				freeMode: true,
				slideToClickedSlide: true,
				mousewheel: {
					invert: true,
				},
				on: {
					click: function (swiper, event) {
						swiper.slides.forEach(slide => {
							slide.classList.remove('swiper-slide-active', 'active');
						});
						if (swiper.clickedSlide) {
							swiper.clickedSlide.classList.add(
								'swiper-slide-active',
								'active'
							);
						}
					},

					// Une fois Swiper initialisé
					init: function (swiper) {
						const hash = window.location.hash;

						if (hash && hash !== '#start') {
							const targetIndex = Array.from(swiper.slides).findIndex(slide => {
								const a = slide.querySelector('a');
								return a && a.hash === hash;
							});
							if (targetIndex !== -1) {
								swiper.slideTo(targetIndex, 0);

								swiper.slides.forEach(slide =>
									slide.classList.remove('swiper-slide-active', 'active')
								);
								const targetSlide = swiper.slides[targetIndex];
								targetSlide.classList.add('swiper-slide-active', 'active');
							}
						}
					},
				},
			});
		});
	}

	function pauseVideoShortcode() {
		var video = document.getElementsByClassName('wp-video-shortcode');
		if (video != 'undefined') {
			for (var i = 0; i < video.length; i++) {
				video[1].pause();
			}
		}
	}

	// --------------------------------------------------------------------------------
	// slider  events
	// --------------------------------------------------------------------------------
	initSwiperEvents();

	function initSwiperEvents() {
		var swiperEvents = new Swiper('.swiper-events', {
			slidesPerView: 1,
			slidesPerGroup: 1,
			autoHeight: false,
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
	}

	// --------------------------------------------------------------------------------
	// slider campus events
	// --------------------------------------------------------------------------------

	function initSwiperEventsCampus() {
		var span = document.getElementsByClassName('swiper-events-campus');
		if (span.length > 0) {
			span[0].children[0].classList.add('swiper-wrapper');
			var swiperEvents = new Swiper('.swiper-events-campus', {
				modules: [Navigation, Pagination, HashNavigation, Autoplay, Keyboard],
				slidesPerView: 1,
				slidesPerGroup: 1,
				autoHeight: false,
				spaceBetween: 10,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				loop: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				navigation: {
					nextEl: '.events-slider-dbevent .swiper-button-next',
					prevEl: '.events-slider-dbevent .swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
					},

					1200: {
						spaceBetween: 0,
						slidesPerView: 1,
						slidesPerGroup: 1,
					},
				},
			});
		}
	}

	// --------------------------------------------------------------------------------
	// slider campus achievements
	// --------------------------------------------------------------------------------

	function initSwiperAchievementsCampus() {
		var achievements = document.getElementsByClassName(
			'swiper-campus-achievements'
		);
		if (achievements.length > 0) {
			var swiperArgs = {
				modules: [Navigation, Pagination, HashNavigation, Autoplay, Keyboard],
				slidesPerView: 1,
				slidesPerGroup: 1,
				autoHeight: true,
				spaceBetween: 15,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				breakpoints: {
					640: {
						slidesPerView: 2,
						slidesPerGroup: 2,
					},
					1024: {
						slidesPerView: 3,
						slidesPerGroup: 3,
					},
				},
			};

			// init
			var swiperAchievements = new Swiper(
				'.swiper-campus-achievements',
				swiperArgs
			);

			// clic action
			$('.categories span').on('click', function () {
				gsap.fromTo(
					'.swiper-campus-achievements',
					{ opacity: 1 },
					{ opacity: 0, duration: 1 }
				);

				var filter = $(this).data('category');

				if (filter == 'all') {
					$('.swiper-campus-achievements [data-filter]')
						.removeClass('non-swiper-slide')
						.addClass('swiper-slide')
						.show();
					swiperAchievements.destroy();
					swiperAchievements = new Swiper(
						'.swiper-campus-achievements',
						swiperArgs
					);
				} else {
					$('.swiper-campus-achievements .swiper-slide')
						.not("[data-filter='" + filter + "']")
						.addClass('non-swiper-slide')
						.removeClass('swiper-slide')
						.hide();
					$(".swiper-campus-achievements [data-filter='" + filter + "']")
						.removeClass('non-swiper-slide')
						.addClass('swiper-slide')
						.attr('style', null)
						.show();
					swiperAchievements.destroy();
					swiperAchievements = new Swiper(
						'.swiper-campus-achievements',
						swiperArgs
					);
				}

				gsap.fromTo(
					'.swiper-campus-achievements',
					{ opacity: 0 },
					{ opacity: 1, duration: 1 }
				);
			});
		}
	}

	initSwiperAchievementsCampus();

	// --------------------------------------------------------------------------------
	// slider students games
	// --------------------------------------------------------------------------------

	function initSwiperStudentsGames() {
		var swiperGames = new Swiper('.swiper-students-games', {
			modules: [Navigation, Pagination, HashNavigation, Autoplay, Keyboard],
			slidesPerView: 1,
			slidesPerGroup: 1,
			autoHeight: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-students-game .swiper-button-next',
				prevEl: '.swiper-students-game .swiper-button-prev',
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
			},
		});
	}

	// --------------------------------------------------------------------------------
	// slider TIMELINE history
	// --------------------------------------------------------------------------------

	function initSwiperTimeline() {
		SwiperTimeline = new Swiper('.timeline-slider ', {
			modules: [FreeMode],
			slidesPerView: 'auto',
			grabCursor: true,
			loop: false,
			freeMode: true,
		});
	}

	// --------------------------------------------------------------------------------
	//  slider inscription
	// --------------------------------------------------------------------------------

	if (document.querySelector('.swiper-inscription') !== null) {
		var SwiperInscription = new Swiper('.swiper-inscription', {
			modules: [Pagination, Autoplay],
			slidesPerView: '1',
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
			},
			pagination: {
				el: '.inscription-info .swiper-pagination',
				clickable: true,
			},
		});
	}

	// --------------------------------------------------------------------------------
	// slider gallery image video
	// --------------------------------------------------------------------------------

	function initSwiperGalleryImageVideos() {
		new Swiper('.gallery-image-video-slider .swiper', {
			modules: [Pagination, Navigation],
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 15,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.gallery-image-video-slider .swiper-button-next',
				prevEl: '.gallery-image-video-slider .swiper-button-prev',
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 4,
				},
			},
		});
	}

	initSwiperGalleryImageVideos();

	function initSwiperPeople() {
		new Swiper('.slider-people .swiper', {
			modules: [Pagination, Navigation],
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 15,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.slider-people .swiper-button-next',
				prevEl: '.slider-people .swiper-button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
	}

	initSwiperPeople();

	function initSliderLogoCompanies() {
		new Swiper('.slider-logo-companies .swiper', {
			modules: [Pagination, Navigation, Grid],
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: 15,
			grid: {
				rows: 3,
				fill: 'row',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.slider-logo-companies .swiper-button-next',
				prevEl: '.slider-logo-companies .swiper-button-prev',
			},
			breakpoints: {
				640: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					grid: {
						rows: 3,
					},
				},

				768: {
					slidesPerView: 5,
					slidesPerGroup: 5,
					grid: {
						rows: 3,
					},
				},
				1024: {
					slidesPerView: 7,
					slidesPerGroup: 7,
					grid: {
						rows: 3,
					},
				},
			},
		});
	}

	initSliderLogoCompanies();

	// --------------------------------------------------------------------------------
	// Campus slider on archive page campus
	// --------------------------------------------------------------------------------

	initSwiperTimeline();

	initSwiperEventsCampus();
	initSwiperStudentsGames();

	enableSwiperOnglet();
	enableSwiperContentBig();
	enableSwiperSimple();

	function activeBullet(slider) {
		let target = slider.activeIndex;

		let activeNavEl = slider.el.parentNode.querySelector(
			'.nav-slide-onglet-move .active-nav'
		);

		// onglet qui se déplace
		if (activeNavEl) {
			let item_number = slider.pagination.bullets.length;
			activeNavEl.style.marginLeft = target * (100 / item_number) + '%';
		}

		// changer custom bullet pagination
		let bullets = slider.el.parentNode.querySelectorAll(
			'.swiper-bullet-custom'
		);
		if (bullets) {
			// Check each bullet element if it has slideNumber class
			bullets.forEach(bullet => {
				let bulletData = parseInt(bullet.getAttribute('data-target'));

				if (bulletData !== parseInt(target)) {
					bullet.classList.remove('swiper-pagination-bullet-active');
				} else {
					bullet.classList.add('swiper-pagination-bullet-active');
				}
			});
		}
	}

	var $item_number = [];
	var $target;

	// onglet slider with nav moving
	$('.nav-slide-onglet-move').each(function (i) {
		$item_number.push($(this).find('.swiper-pagination-bullet').length);
		$target = $(this).find('.swiper-pagination-bullet-active').data('target');
		$(this)
			.find('.swiper-pagination-bullet, .active-nav')
			.css('width', 100 / $item_number + '%');
		$(this)
			.find('.active-nav')
			.css('margin-left', $target * (100 / $item_number) + '%');
	});

	$(document).on('click', '.nav-slide-onglet-move span', function (e) {
		$item_number = $(this).parent().find('.swiper-pagination-bullet').length;
		$target = $(this).data('target');
		$('.active-nav').css('margin-left', $target * (100 / $item_number) + '%');
	});

	//---------------------------//
	// STICKY ON THE SIDE LINKS DOCUMENTATION ET ENTRETIEN
	//---------------------------//

	if (document.querySelector('.fixed-links') !== null) {
		var scroll = $(window).scrollTop();
		var wH = $(window).height() / 3;
		if (
			document.querySelector('.single-programmes') !== null &&
			$(window).height() > 600
		) {
			FixedLink();
			function FixedLink() {
				scroll = $(window).scrollTop();
				if (scroll > wH) {
					$('.fixed-links').fadeIn();
				} else if (scroll <= wH) {
					$('.fixed-links').fadeOut();
				}
			}
			$(window).scroll(function (event) {
				FixedLink();
			});
		} else {
			$('.fixed-links').fadeIn();
		}
	}

	//---------------------------//
	// STICKY HEADER SUB MENU
	//---------------------------//

	if (document.querySelector('.sticky-header') !== null) {
		var stichyHeader = $('.sticky-header');
		var stickyHeaderHeight = stichyHeader.outerHeight();
		$('body').css('marginTop', stickyHeaderHeight + 'px');

		if (document.querySelector('.sticky') !== null) {
			var EltoStick = $('.sticky');
			EltoStick.find('.container').wrapAll("<div class='sticky-content' />");
			var EltoStickHeight = EltoStick.find('.sticky-content').outerHeight();
			EltoStick.css('height', EltoStickHeight + 'px');
			EltoStick.find('.sticky-content').css('top', stickyHeaderHeight + 'px');

			$(window).on('resize', function () {
				EltoStickHeight = EltoStick.find('.sticky-content').outerHeight();
				EltoStick.css('height', EltoStickHeight + 'px');
			});
			$(window).scroll(function (event) {
				detectSticky();
			});

			detectSticky();
		}

		function detectSticky() {
			var scroll = $(window).scrollTop();
			var stickyPosition = EltoStick.offset().top - stickyHeaderHeight;

			if (scroll > stickyPosition) {
				EltoStick.addClass('active');
			} else if (scroll <= stickyPosition) {
				EltoStick.removeClass('active');
			}
		}
	}

	//---------------------------//
	// VIDEO HERO HEADER
	//---------------------------//

	var video = document.getElementById('video_header');
	var videoexist = false;
	var reload = false;

	function reloadVid() {
		if (reload == false) {
			video.load();
			reload = true;
		}
	}

	function playVid() {
		video.play();
	}

	function pauseVid() {
		video.pause();
	}

	function stopVid() {
		video.pause();
		video.currentTime = 0.1; //setting to zero breaks iOS 3.2, the value won't update, values smaller than 0.1 was causing bug as well.
	}

	function replacevideo() {
		var sources = document.querySelectorAll('#video_header source');
		for (var i = 0; i < sources.length; i++) {
			var src = sources[i].getAttribute('data-src');
			sources[i].setAttribute('src', src);
		}
	}

	function videoHero() {
		//if ($(window).width() > 768) {
		if (video !== null) {
			videoexist = true;
			$('#video_header').css('display', 'block');
			replacevideo();
			reloadVid();
			playVid();
		}
		/*
		} else {
			if (video !== null) {
				stopVid();
				$('#video_header').css('display', 'none');
			}
		}*/
	}

	videoHero();
	$(window).on('resize', function () {
		videoHero();
	});

	// Select Cursus
	if ($('#submit-cursus').length > 0) {
		$('#submit-cursus').click(function () {
			window.location.href = $('#select-cursus').val();
		});
	}

	// Select links general
	$('#type-post').change(function (e) {
		var $news_url = $('#news_url').val();
		window.location.href = $news_url + '?category=' + $(this).val();
	});

	// Selects links - sucess stories
	$('#category, #location').change(function (e) {
		var $news_url = $('#news_url').val();
		var $category = $('#category').val();
		var $location = $('#location').val();
		window.location.href =
			$news_url + '?category=' + $category + '&location=' + $location;
	});
});
